const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the Event Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Events} Events the resource defined to manage Events
 * @argument {EventParticipation} EventParticipation the resource defined to manage EventParticipation
 */
app.directive('eventViewer', ['Application', 'Authorization', 'Analyze', 'Events', 'EventParticipation', 'ContentAuth', '$window', '$translate', function (Application, Authorization, Analyze, Events, EventParticipation, ContentAuth, $window, $translate) {
  return {
    restrict: 'E',
    scope: {
      fullData: '=',
      expectData: '@'
    },
    template: require('../../templates/directives/event-viewer.html'),
    controller: ['$scope', function ($scope) {
      if ($scope.expectData === 'true') {
        $scope.expectData = true;
      }
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      var adminRoles = ['admin', 'creator'];
      self.user = Authorization.getAuthToken().user;
      self.isAdmin = adminRoles.indexOf(self.user.role) !== -1;
      self.fullFields = 'user,title,hosts,category,linked_category,description,image,banner_image,tags,start_date,end_date,location,online_location,online,explore_hide,mandatory,public,invite_only,max_attendees,wait_list,attendees,allow_wait,max_wait,instructors,related_events,pre_content,supplemental_notes,registration_disabled,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private';
      self.evnt = {};
      self.activeTab = 'information';
      self.url = Application.navigation.getUrl();
      self.inEditing = new RegExp('edit').test(self.url);
      self.xOut = function() {
        Application.navigation.back();
      };

      self.contentId = routeParameters.id || null;

      self.image = function () {
        if (self.evnt.banner_image || self.evnt.image) {
          var imageUrl = self.evnt.banner_image ? self.evnt.banner_image : self.evnt.image;
          return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
        }
        return '';
      };

      self.showSupplemental = function() {
        if (!self.evnt) {
          return false;
        }
        if (self.evnt.pre_content && self.evnt.pre_content.links && self.evnt.pre_content.links.length) {
          return true;
        }
        if (self.evnt.supplemental_notes) {
          return true;
        }
        return false;
      };

      self.formatDates = function() {
        if (!self.evnt || !self.evnt.start_date || !self.evnt.end_date) {
          self.formattedDate = false;
          return;
        }

        var start = moment(new Date(self.evnt.start_date).toISOString());
        var end = moment(new Date(self.evnt.end_date).toISOString());
        self.formattedDate = start.format('MMMM Do, YYYY');
        self.formattedTime = start.format('h:mma') + '-' + end.format('h:mma');
      };

      self.setDataWatch = function() {
        var items = ['viewer.evnt.start_date', 'viewer.evnt.end_date'];

        angular.forEach(items, function(item) {
          $scope.$watch(item, function(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
              self.formatDates();
            }
          });
        });

        $scope.$watch('fullData.related_events', function(newVal, oldVal) {
          if (!newVal || !newVal.length) {
            return;
          }
          if (!self.relatedData) {
            self.relatedData = {};
          }
          var eventsLength = newVal.length;
          var eventsString = newVal.join(',');
          Events.find({
            '_id': '$in,' + eventsLength + ',' + eventsString,
            fields: 'title'
          }).$promise.then(function(data) {
            angular.forEach(data, function(item) {
              self.relatedData[item._id] = item;
            });
          });
        }, true);
      };

      self.setSpotsLeft = function() {
        if (!self.evnt.max_attendees || !self.evnt.attendees) {
          self.spotsLeft = null;
          return;
        }
        self.spotsLeft = self.evnt.max_attendees - self.evnt.attendees.length;
        if (self.spotsLeft < 0) {
          self.spotsLeft = 0;
        }
      };

      self.setState = function() {
        // signedUp || waiting || canJoin || canWait
        self.userState = null;
        if (new Date(self.evnt.start_date) < new Date()) {
          return;
        }
        var userId = self.user._id.toString();
        var spotsLeft = self.spotsLeft;
        var waitAvailable = self.evnt.allow_wait && self.evnt.wait_list.length < self.evnt.max_wait;
        // show leave event
        for (var i = 0; i < self.evnt.attendees.length; i++) {
          if (self.evnt.attendees[i].toString() === userId) {
            self.userState = 'signedUp';
            return;
          }
        }
        // show leave waitlist
        for (var i = 0; i < self.evnt.wait_list.length; i++) {
          if (self.evnt.wait_list[i].toString() === userId) {
            self.userState = 'waiting';
            return;
          }
        }
        if (self.evnt.registration_disabled) {
          return;
        }
        // show join
        if (spotsLeft) {
          self.userState = 'canJoin';
          return;
        }
        // show wait
        if (waitAvailable) {
          self.userState = 'canWait';
        }
        // no options
      };

      self.makeIcs = function() {
        var addZero = function(value) {
          return (value < 10 ? '0' : '') + value;
        };

        var formatDate = function(date) {
          if (!date) {
            return '';
          }
          return date.getFullYear() + addZero(date.getMonth() + 1) + addZero(date.getDate());
        };

        var formatDateTime = function(dateTime) {
          return '' + dateTime.getUTCFullYear() + addZero(dateTime.getUTCMonth() + 1) + addZero(dateTime.getUTCDate()) + 'T' + addZero(dateTime.getUTCHours()) + addZero(dateTime.getUTCMinutes()) + addZero(dateTime.getUTCSeconds()) + 'Z';
        };

        var calculateDuration = function() {
          var start = new Date(self.evnt.start_date);
          var end = new Date(self.evnt.end_date);
          if (!start || !end) {
            return '';
          }
          var seconds = Math.abs(end.getTime() - start.getTime()) / 1000;
          var days = Math.floor(seconds / 86400);
          seconds -= days * 86400;
          var hours = Math.floor(seconds / 3600);
          seconds -= hours * 3600;
          var minutes = Math.floor(seconds / 60);
          seconds -= minutes * 60;
          return (start.getTime() > end.getTime() ? '-' : '') + 'P' + (days > 0 ? days + 'D' : '') + (hours || minutes || seconds ? 'T' + hours + 'H' : '') + (minutes || seconds ? minutes + 'M' : '') + (seconds ? seconds + 'S' : '');
        };

        var div = document.createElement("div");
        div.innerHTML = self.evnt.description;

        var eventString = 'BEGIN:VCALENDAR\n' +
          'VERSION:2.0\n' +
          'PRODID:-//continu ' + self.contentId + '\n' +
          'METHOD:PUBLISH\n' +
          'BEGIN:VEVENT\n' +
          'UID:' + new Date().getTime() + '@' + self.evnt._id + '\n' +
          'DTSTAMP:' + formatDateTime(new Date()) + '\n' +
          'TITLE:' + (self.evnt.title || 'Event') + '\n' +
          'DTSTART:' + formatDateTime(new Date(self.evnt.start_date)) + '\n' +
          'DTEND:' + formatDateTime(new Date(self.evnt.end_date)) + '\n' +
          'URL:' + 'https://' + Application.navigation.getHost() + '/#/view/events/' + self.evnt._id + '\n' +
          'SUMMARY:' + (div.innerText || div.textContent || 'No Summary') + '\n' +
          'LOCATION:' + (self.evnt.location || self.evnt.online_location || 'None Provided') + '\n' +
          'END:VEVENT\n' +
          'END:VCALENDAR';

          var url = 'http://www.google.com/calendar/event?action=TEMPLATE&text={t}&dates={s}/{e}&details={d}&location={l}&sprop=website:{u}'
          var inserts = {
            t: encodeURIComponent(self.evnt.title),
            d: encodeURIComponent(self.evnt.description),
            s: formatDateTime(new Date(self.evnt.start_date)),
            e: formatDateTime(new Date(self.evnt.end_date)),
            p: calculateDuration(self.evnt.start_date, self.evnt.end_date),
            l: encodeURIComponent(self.evnt.location),
            u: encodeURIComponent('https://' + Application.navigation.getHost() + '/#/view/events/' + self.evnt._id),
          };

          for (var item in inserts) {
            var re = new RegExp('\\{' + item + '\\}', 'g');
            url = url.replace(re, inserts[item]);
          }

          self.gCalLink = url;
          self.iCalDl = 'eventasics?content=' + $window.escape(eventString);
      };

      self.joinEvent = function() {
        EventParticipation.join({
          eventId: routeParameters.id,
          userId: self.user._id,
          fields: self.fullFields
        }, {}, function (data) {
          Analyze.record({resource: 'events'}, {action: 'signup', event: self.evnt._id});
          Application.analyticsProvider.trackEvent('event_signup', {content: self.evnt._id, content_type: 'event', title: self.evnt.title});
          self.evnt.attendees = data.attendees;
          self.evnt.wait_list = data.wait_list;
          self.setSpotsLeft();
          self.setState();
          self.host = null;
          if (self.evnt.hosts && self.evnt.hosts.length) {
            self.host = self.evnt.hosts[0];
          }
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['modules.notifications.event_youHaveJoined']});
        }, function (error) {
          console.log('Could not join event ', routeParameters.id, error);
        });
      };

      self.joinWaitlist = function() {
        EventParticipation.waitlist({
          eventId: routeParameters.id,
          userId: self.user._id,
          fields: self.fullFields
        }, {}, function (data) {
          Analyze.record({resource: 'events'}, {action: 'waitlist', event: self.evnt._id});
          Application.analyticsProvider.trackEvent('event_waitlist', {content: self.evnt._id, content_type: 'event', title: self.evnt.title});
          self.evnt.attendees = data.attendees;
          self.evnt.wait_list = data.wait_list;
          self.setSpotsLeft();
          self.setState();
          self.host = null;
          if (self.evnt.hosts && self.evnt.hosts.length) {
            self.host = self.evnt.hosts[0];
          }
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['modules.notifications.event_joinedWaitlist'] });
        }, function (error) {
          console.log('Could not join event waitlist ', routeParameters.id, error);
        });
      };

      self.leaveEvent = function() {
        EventParticipation.cancel({
          eventId: routeParameters.id,
          userId: self.user._id,
          fields: self.fullFields
        }, {}, function (data) {
          if (self.userState === 'signedUp') {
            Analyze.record({resource: 'events'}, {action: 'signout', event: self.evnt._id});
            Application.analyticsProvider.trackEvent('event_signout', {content: self.evnt._id, content_type: 'event', title: self.evnt.title});
          }
          if (self.userState === 'waiting') {
            Analyze.record({resource: 'events'}, {action: 'withdraw', event: self.evnt._id});
            Application.analyticsProvider.trackEvent('event_withdraw', {content: self.evnt._id, content_type: 'event', title: self.evnt.title});
          }
          self.evnt.attendees = data.attendees;
          self.evnt.wait_list = data.wait_list;
          self.setSpotsLeft();
          self.setState();
          self.host = null;
          if (self.evnt.hosts && self.evnt.hosts.length) {
            self.host = self.evnt.hosts[0];
          }
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['modules.notifications.event_leaveEvent'] });
        }, function (error) {
          console.log('Could not leave event ', routeParameters.id, error);
        });
      };

      self.initialize = function () {
        if (!routeParameters.id && !$scope.fullData) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }
        if ($scope.fullData) {
          self.previewMode = true;
          self.evnt = $scope.fullData;
          self.formatDates();
          // Watch dates
          // Watch related
          self.setDataWatch();
          self.setSpotsLeft();
          self.host = null;
          if (self.evnt.hosts && self.evnt.hosts.length) {
            self.host = self.evnt.hosts[0];
          }
          return;
        }

        Events.get({
          subresource: routeParameters.id, 
          fields: self.fullFields,
          'user-populate': 'first_name,last_name,email',
          'related_events-populate': 'title'
        }, function (data) {
          ContentAuth.allowView(data).then(function(allowed) {
            if (!allowed) {
              Application.messaging.addMessage({type: 'error', text: 'You don’t have permission to access this content, please contact your administrator if you believe this is a mistake', duration: 5});
              Application.navigation.back();
              return;
            }
            Analyze.record({resource: 'views'}, {content: data._id, content_type: 'event'});
            Application.analyticsProvider.trackEvent('event_viewed', {content: self.evnt._id, content_type: 'event', title: self.evnt.title});
            self.evnt = data;
            self.formatDates();
            self.makeIcs();
            self.setSpotsLeft();
            self.setState();
            self.host = null;
            if (self.evnt.hosts && self.evnt.hosts.length) {
              self.host = self.evnt.hosts[0];
            }
          });
        }, function (error) {
          console.log('Error occured getting event ', routeParameters.id, error);
        });
      };

      if ($scope.expectData) {
        var fullWatch = $scope.$watch('fullData', function(newVal, oldVal) {
          if (!newVal) {
            return;
          }
          self.initialize();
          fullWatch();
        });
        return;
      }

      $translate(['modules.notifications.event_youHaveJoined', 'modules.notifications.event_leaveEvent', 'modules.notifications.event_joinedWaitlist']).then(function(translations){
        self.translations = translations;
        self.initialize();
      });
    }],
    controllerAs: 'viewer'
  };
}]);
